import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 mx-4 md:mx-6 mb-4 md:mb-6 rounded-2xl overflow-hidden">
      <div className="px-6 md:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-flex items-center gap-2 mb-6 whitespace-nowrap">
              <span className="w-10 h-10 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-heading text-2xl">
                51
              </span>
              <span className="text-background-50 font-heading text-2xl">
                51网址导航
              </span>
            </Link>
            <p className="text-background-400 text-sm leading-relaxed">
              全网每日网红塌房黑料吃瓜视频实时追踪平台，你的吃瓜第一站。
            </p>
          </div>

          <div>
            <h4 className="text-background-50 font-medium text-sm mb-4">
              快速导航
            </h4>
            <nav className="flex flex-col gap-2.5">
              <Link to="/" className="text-background-400 hover:text-background-200 text-sm transition-colors duration-200 whitespace-nowrap">首页</Link>
              <Link to="/category/wanghong-tafang" className="text-background-400 hover:text-background-200 text-sm transition-colors duration-200 whitespace-nowrap">网红塌房</Link>
              <Link to="/category/heiliao-baoguang" className="text-background-400 hover:text-background-200 text-sm transition-colors duration-200 whitespace-nowrap">黑料曝光</Link>
              <Link to="/category/chigua-shipin" className="text-background-400 hover:text-background-200 text-sm transition-colors duration-200 whitespace-nowrap">吃瓜视频</Link>
              <Link to="/about" className="text-background-400 hover:text-background-200 text-sm transition-colors duration-200 whitespace-nowrap">关于我们</Link>
            </nav>
          </div>

          <div>
            <h4 className="text-background-50 font-medium text-sm mb-4">
              关注我们
            </h4>
            <div className="flex flex-col gap-2.5">
              <a href="https://weibo.com" target="_blank" rel="noopener noreferrer nofollow" className="text-background-400 hover:text-background-200 text-sm transition-colors duration-200 flex items-center gap-2 whitespace-nowrap">
                <i className="ri-weibo-line text-base w-5 h-5 flex items-center justify-center"></i>
                新浪微博
              </a>
              <a href="https://www.douyin.com" target="_blank" rel="noopener noreferrer nofollow" className="text-background-400 hover:text-background-200 text-sm transition-colors duration-200 flex items-center gap-2 whitespace-nowrap">
                <i className="ri-tiktok-line text-base w-5 h-5 flex items-center justify-center"></i>
                抖音
              </a>
              <a href="https://www.xiaohongshu.com" target="_blank" rel="noopener noreferrer nofollow" className="text-background-400 hover:text-background-200 text-sm transition-colors duration-200 flex items-center gap-2 whitespace-nowrap">
                <i className="ri-booklet-line text-base w-5 h-5 flex items-center justify-center"></i>
                小红书
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-background-50 font-medium text-sm mb-4">
              订阅更新
            </h4>
            <p className="text-background-400 text-sm mb-3">
              第一时间获取最新吃瓜资讯
            </p>
            <div className="flex gap-0">
              <input
                type="email"
                placeholder="输入邮箱地址"
                className="flex-1 px-4 py-2.5 text-sm bg-background-800 text-background-200 border border-background-700 rounded-l-full outline-none placeholder:text-background-500"
              />
              <button className="px-4 py-2.5 bg-primary-500 text-background-50 rounded-r-full hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                <i className="ri-arrow-right-line text-sm w-5 h-5 flex items-center justify-center"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="relative px-6 md:px-12 pb-8">
        <div className="text-background-800 font-heading text-6xl md:text-8xl text-center select-none leading-none opacity-20 whitespace-nowrap overflow-hidden">
          51网址导航
        </div>
      </div>

      <div className="border-t border-background-800/50 px-6 md:px-12 py-5">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-500 text-xs">
            &copy; 2026 51网址导航 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-500 hover:text-background-300 text-xs transition-colors duration-200 whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-background-500 hover:text-background-300 text-xs transition-colors duration-200 whitespace-nowrap">用户协议</a>
            <a href="#" className="text-background-500 hover:text-background-300 text-xs transition-colors duration-200 whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}